import React__default from 'react';
import QsrBillBreakup from '../Cells/BillBreakup.js';
import QsrOrderStatus from '../Molecules/QsrOrderStatus.js';
import QsrOrderSuccessShimmer from '../Components/Organisms/QsrOrderSuccess/Web/index.shimmer.js';
import classNames from './../external_lib/classnames/index.js';

function QsrOrderSuccess(_a) {
    var variant = _a.variant, tokenNo = _a.tokenNo, items = _a.items, loading = _a.loading, classes = _a.classes;
    if (loading)
        return React__default.createElement(QsrOrderSuccessShimmer, null);
    return (React__default.createElement("div", { className: classNames('qsr-order-success', classes) },
        React__default.createElement("div", { className: "qsr-order-success__header" },
            React__default.createElement(QsrOrderStatus, { variant: variant })),
        React__default.createElement("div", { className: "qsr-order-success__body" },
            React__default.createElement(QsrBillBreakup, { tokenNo: tokenNo, items: items }))));
}

export { QsrOrderSuccess as default };
//# sourceMappingURL=QsrOrderSuccess.js.map
